import { render, staticRenderFns } from "./category-content-list.vue?vue&type=template&id=3578a7e0&scoped=true&"
import script from "./category-content-list.vue?vue&type=script&lang=ts&"
export * from "./category-content-list.vue?vue&type=script&lang=ts&"
import style0 from "./category-content-list.vue?vue&type=style&index=0&id=3578a7e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3578a7e0",
  null
  
)

export default component.exports